import { awaitPendingCreditCardUpdate, updateCreditCard } from '@pressreader/account-billing';

import ndRes from 'deprecated/nd.res';

import ndAlert from 'nd.alert';

/**
 * @typedef CreditCard
 * @type Object
 *
 * @property {String} cardholderName - full name of card holder
 * @property {String} lastFourDigits - last four digits of card number
 * @property {String} cardType - type of credit card (Visa, Master etc.)
 * @property {Number} expirationMonth - a month of card expiration
 * @property {Number} expirationYear - a year of card expiration
 * @property {Address} billingAddress - a billing address associated with credit card
 */

type UpdateCreditCardResult = {
    status: 'Approved' | 'Pending' | 'Declined' | 'Error';
    challengeUrl: string;
    updateId: string;
};
// legacy API do not use for new features
async function updateCreditCardWithConfirmationAsync(data): Promise<UpdateCreditCardResult> {
    let result = await updateCreditCard(data);
    if (result.status !== 'Pending') {
        return result;
    }

    let wnd = window.open(result.challengeUrl);
    if (!wnd) {
        await ndAlert().confirm(ndRes.val('v7.Client.Dialogs.ConfirmCreditCard'), ndRes.val('Buttons.Cancel.Text'), ndRes.val('Buttons.Confirm'));
        wnd = window.open(result.challengeUrl);
    }

    result = await awaitPendingCreditCardUpdate(result.updateId);
    wnd?.close();

    return result;
}

export { updateCreditCardWithConfirmationAsync };
